<template>
  <div class="a7-painel-analise-list-mobile">
    <div class="">
      <a7-painel-analise-parameter v-model="localFilters"/>
    </div>
    <div v-for="element in itens" :key="element.key" v-if="itens.length">
      <div class="group" @click="collapse( element )">
        <gw-icon
          class="group-icon"
          :icon="!collapseds.includes(element) ?  'fa-chevron-down': 'fa-chevron-right'"/>
        <span class="group-title">{{element.descricao}}</span>
      </div>
      <gw-list :items="element.itens" v-if="!collapseds.includes(element)" separator>
        <template v-slot:listItem="{ item }">
          <a7-painel-analise-item-mobile :item="item"  />
        </template>
      </gw-list>
    </div>
    <div v-if="!itens.length">
      <h3 class="empty-message"> {{`${$t('PainelAnalise.ui.arrayVazio')}`}} </h3>
    </div>
  </div>
</template>

<script>
import {
  GwList,
  GwIcon,
  GwGroupingPane
} from 'guaxinim-web'
import A7PainelAnaliseItemMobile from './A7PainelAnaliseItemMobile'
import A7PainelAnaliseParameter from './A7PainelAnaliseParameter'

export default {
  name: "a7-painel-analise-list-mobile",
  components: {
    GwList,
    GwIcon,
    GwGroupingPane,
    A7PainelAnaliseItemMobile,
    A7PainelAnaliseParameter
  },
  props: {
    itens: {
      type: Array,
      required: true
    },
    value: {
      type: Object
    }
  },
  data: () => ({
    collapseds: [],
    localFilters: {}
  }),
  methods: {
    collapse (element) {
      (this.collapseds.includes(element))
        ? this.collapseds.splice(this.collapseds.indexOf(element), 1)
        : this.collapseds.push(element)
    },
    emitInput(){
      this.$emit('input', this.localFilters)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.localFilters = value
      }
    },
    localFilters() {
      this.emitInput()
    }
  }
}
</script>

<style lang="scss" scoped>
$tamanhoFonteTitulo: 1.45em;
$light-grey: #d1d1d1;

.a7-painel-analise-list-mobile{
  display: flex;
  flex-direction: column;
  margin: 0px 10px;
}

.group {
  padding: 5px 0px;
  border-bottom: 1px solid $light-grey;
  .group-icon {
    width: 15px;
    font-size: 16px;
    text-align: center;
  }
  .group-title {
    font-size: $tamanhoFonteTitulo;
    font-weight: bold;
  }
}


.empty-message {
  margin-left: 10px;
}
</style>
